// OTA予約登録 / URL発行まわりで3画面（予約管理・パスポート・チェックイン）が共有する型。
//   表示コンポーネント OtaReservationForm / IssuedUrlPanel が受け取る props の土台。
//   ロジック（fetch + state 更新）は各ページ側に残し、ここでは「形」だけを共通化する。

// OTA予約登録フォームの入力値。
export interface OtaFormState {
  property_id: string;
  checkin_date: string;
  checkout_date: string;
  guest_count: number;
  guest_name: string;
  source_channel: string;
  ota_reservation_code: string;
}

// フォーム初期値（各画面の reset で共用）。
export const EMPTY_OTA_FORM: OtaFormState = {
  property_id: '', checkin_date: '', checkout_date: '', guest_count: 1,
  guest_name: '', source_channel: 'airbnb', ota_reservation_code: '',
};

// 物件プルダウンの選択肢。
export interface PropertyOpt { id: string; name: string; }

// URL発行結果。自社予約のメール文面(mail*)・即時救済(rescue)はオプショナルで、
// OTAのみを扱う画面（予約管理）は url/code/checkin だけを渡せばよい。
export interface IssuedInfo {
  reservationId: string;
  isOta: boolean;
  url: string;
  codeUrl?: string;   // 予約番号を含むURL（OTAのみ。/passport?code=XXXX）
  code?: string;
  checkin?: string;
  mailTo?: string;
  mailSubject?: string;
  mailText?: string;
  rescue?: boolean;
}
